<template>
  <div class="row-fluid">
    <div class="my-0 section-shaped">
      <div class="row">
        <div class="col-md-2">&nbsp;</div>
        <div v-if="alertDetails.display" class="col-md-6" style="padding-top: 5px">
          <b-alert v-model="alertDetails.display" :variant="alertDetails.type" show dismissible>
            {{ alertDetails.message }}
          </b-alert>
        </div>
      </div>
      <div class="shape shape-style-1 shape-default"></div>

      <div class="container pb-lg">
        <div class="row justify-content-between align-items-center">
          <div class="col-lg-5 mb-5 mb-lg-0">
            <h1 class="text-secondary font-weight-light">Shop Airtime, Data, Grocery Vouchers &amp; More Across Southern Africa</h1>
            <p class="lead text-secondary mt-4">Buy online from South Africa, Zimbabwe and Malawi. Collect locally at trusted partners including Gain Cash &amp; Carry.</p>
            <div class="row mt-4">
              <div class="col">
                <router-link to="/country">
                  <button class="btn text-white" style="background-color: #003366;" type="button">
                    Shop Online Now
                  </button>
                </router-link>
              </div>
            </div>
          </div>
          <div class="col-lg-6 mb-lg-auto">
            <div class="rounded shadow-lg overflow-hidden transform-perspective-right">
              <img src="land/phone_2.jpg" class="d-block w-100" alt="Umbai cross-border ecommerce platform for airtime and grocery vouchers">
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- Gain Cash and Carry Promo Banner -->
    <section class="gain-promo-section py-5">
      <div class="container">
        <div class="gain-promo-card">
          <div class="row align-items-center">
            <div class="col-md-2 text-center mb-3 mb-md-0">
              <img src="logo/gain.png" alt="Gain Cash and Carry grocery vouchers Zimbabwe" class="gain-logo" />
            </div>
            <div class="col-md-7 mb-3 mb-md-0">
              <span class="gain-badge">NEW</span>
              <h2 class="gain-title">Gain Cash &amp; Carry Grocery Vouchers</h2>
              <p class="gain-subtitle">Now available on Umbai. Purchase grocery vouchers online for collection at any Gain Cash &amp; Carry store in Zimbabwe.</p>
            </div>
            <div class="col-md-3 text-center text-md-right">
              <router-link to="/products?c=zw">
                <button class="btn gain-cta-btn" type="button">Shop Vouchers</button>
              </router-link>
            </div>
          </div>
        </div>
      </div>
    </section>

  </div>
</template>

<script>
import { BCarousel } from "bootstrap-vue/esm/components/carousel/carousel";
import { BCarouselSlide } from "bootstrap-vue/esm/components/carousel/carousel-slide";
import { BAlert } from "bootstrap-vue/esm/components/alert/alert";
import config from "@/settings/config.js";
import * as signalR from "@aspnet/signalr";

export default {
  name: "Landing",
  components: {
    BCarousel,
    BCarouselSlide,
    BAlert,
  },
  data: () => ({
    connection: new signalR.HubConnectionBuilder()
      .withUrl(`${config.gateway}hub/signalr`)
      .build(),
    alertDetails: {
      type: "info",
      message: "",
      display: false,
    },
  }),
  mounted() {
    this.alertMessage();
    this.$store.dispatch("alertmessage/Reset");
    this.registerClient();
    this.getNotified();
  },

  methods: {
    getNotified() {
      this.connection.on(
        "SendNotification",
        (receiverMobile, message, createdOn) => {
          this.alertDetails.display = true;
          this.alertDetails.message =
            message + " View Inbox for more information.";
          this.alertDetails.type = "success";
        }
      );
    },
    registerClient() {
      const user = this.$store.getters["login/user"];
      if (user) {
        let username = user.profile.email;
        if (user.username) username = user.username;
        if (this.connection.state === signalR.HubConnectionState.Connected) {
          this.connection.invoke("RegisterClient", username);
        } else {
          this.connection
            .start()
            .then(() => this.connection.invoke("RegisterClient", username));
        }
      }
    },
    alertMessage() {
      let alertDetails = this.$store.getters["alertmessage/AlertDetails"];
      this.alertDetails.display = alertDetails.display;
      this.alertDetails.message = alertDetails.msg;
      this.alertDetails.type = alertDetails.type;
    },
  },
};
</script>

<style scoped>
.gain-promo-section {
  background: linear-gradient(135deg, #f8f9fa 0%, #e9ecef 100%);
}

.gain-promo-card {
  background: #ffffff;
  border-radius: 16px;
  padding: 2.5rem 2rem;
  box-shadow: 0 10px 40px rgba(0, 0, 0, 0.08);
  border-left: 5px solid #e63946;
  position: relative;
  overflow: hidden;
}

.gain-promo-card::after {
  content: '';
  position: absolute;
  top: 0;
  right: 0;
  width: 200px;
  height: 100%;
  background: linear-gradient(135deg, transparent 0%, rgba(230, 57, 70, 0.04) 100%);
  pointer-events: none;
}

.gain-logo {
  width: 100px;
  height: 100px;
  object-fit: contain;
  border-radius: 12px;
  padding: 8px;
  background: #fff;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.06);
}

.gain-badge {
  display: inline-block;
  background: linear-gradient(135deg, #e63946, #d62839);
  color: #fff;
  font-size: 0.7rem;
  font-weight: 700;
  letter-spacing: 1.5px;
  padding: 4px 14px;
  border-radius: 20px;
  margin-bottom: 0.75rem;
  text-transform: uppercase;
}

.gain-title {
  font-size: 1.6rem;
  font-weight: 700;
  color: #1d3557;
  margin-bottom: 0.5rem;
  line-height: 1.3;
}

.gain-subtitle {
  font-size: 1rem;
  color: #6c757d;
  margin-bottom: 0;
  line-height: 1.6;
}

.gain-cta-btn {
  background: linear-gradient(135deg, #e63946, #d62839);
  color: #fff;
  font-weight: 600;
  font-size: 1rem;
  padding: 12px 32px;
  border-radius: 30px;
  border: none;
  box-shadow: 0 4px 15px rgba(230, 57, 70, 0.35);
  transition: all 0.3s ease;
  text-transform: uppercase;
  letter-spacing: 0.5px;
}

.gain-cta-btn:hover {
  transform: translateY(-2px);
  box-shadow: 0 6px 20px rgba(230, 57, 70, 0.45);
  color: #fff;
}
</style>
